// extracted by mini-css-extract-plugin
export default {"container":"styles_container__r3TNA","flag":"styles_flag__KFfUt","placeholder":"styles_placeholder__zdkvC","placeholderIcon":"styles_placeholderIcon__42kdz"};